module.exports = __webpack_public_path__ + "static/media/iosevka-ss08-bold.6feba0ed.woff2";